import AdminModule from '@features/Admin/Admin.Module';

export default function Home() {
  return <AdminModule />;
}
